Postlogin.CareerCentralSearch = (function () {
    let lastSearchTerm = '';

    // Builds the subtitle's leading <i> icon as a real DOM node so the
    // subtitle can be assembled without ever handing an HTML string
    // (with interpolated, untrusted-shaped search terms) to jQuery's
    // .html()/.append() sinks.
    const buildSubtitleIcon = (iconClass) => {
        const icon = document.createElement('i');
        icon.className = `fa ${iconClass}`;
        icon.setAttribute('aria-hidden', 'true');
        return icon;
    };

    const init = function () {
        let xhr = null;

        $('#career-central-search').on('click', '#clear-search', () => {
            // move cluster list back
            $('#career-central-search > input').val('');
            $('#career-clusters-container,#cluster-careers-container').removeClass('off-screen');
            $('#career-search-results-container .careers').html('');
            $('#career-search-results-container').removeClass('on-screen');
            $('#clear-search').removeClass('shown');
            $('#magnifying-glass').addClass('shown');
        });

        $('#career-central-search > input').on(
            'keyup',
            _.debounce(() => {
                // if a search is in progress, abort it...
                if (xhr != null) {
                    xhr.abort();
                }
                let searchTerm = $('#career-central-search > input').val();

                if (searchTerm === lastSearchTerm) {
                    return;
                }
                lastSearchTerm = searchTerm;

                const vjsSectionId = $('#career-central-search > input').attr('data-section-id') ?? null;
                const categoryId = vjsSectionId ? 1 : null;

                searchTerm = $('<div/>').html(searchTerm).text();
                if (searchTerm === '') {
                    // move cluster list back
                    $('#career-clusters-container,#cluster-careers-container').removeClass('off-screen');
                    $('#career-search-results-container .careers').html('');
                    $('#career-search-results-container').removeClass('on-screen');
                    $('#clear-search').removeClass('shown');
                    $('#magnifying-glass').addClass('shown');
                } else {
                    // move cluster list off screen
                    $('#clear-search').addClass('shown');
                    $('#magnifying-glass').removeClass('shown');
                    $('#career-clusters-container,#cluster-careers-container').addClass('off-screen');
                    $('#career-search-results-container').addClass('on-screen');
                    $('#career-search-results-container .careers').addClass('faded');
                    const subtitle = $('#career-search-subtitle').empty();
                    const searchingTerm = document.createElement('strong');
                    searchingTerm.textContent = `"${searchTerm}"`;
                    subtitle.append(
                        buildSubtitleIcon('fa-search'),
                        document.createTextNode(' Searching for '),
                        searchingTerm,
                        document.createTextNode('...'),
                    );

                    xhr = $.ajax({
                        type: 'POST',
                        url: $('#career-central-search > input').attr('data-search-url'),
                        data: {
                            search_term: searchTerm,
                            section_id: vjsSectionId,
                            category_id: categoryId,
                        },
                        success(data) {
                            $('#career-search-results-container #progress-indicator').remove();
                            $('#career-search-results-container .careers').removeClass('faded');
                            $('#career-search-results-container .careers').html('');
                            if (data.data.length > 0) {
                                const foundSubtitle = $('#career-search-subtitle').empty();
                                const foundCount = document.createElement('strong');
                                foundCount.textContent = data.data.length;
                                const foundTerm = document.createElement('strong');
                                foundTerm.textContent = `"${searchTerm}"`;
                                foundSubtitle.append(
                                    buildSubtitleIcon('fa-thumbs-up'),
                                    document.createTextNode(' Found '),
                                    foundCount,
                                    document.createTextNode(` career${data.data.length === 1 ? '' : 's'} for `),
                                    foundTerm,
                                );
                                $.each(data.data, (index, career) => {
                                    $('#career-search-results-container .careers').append(DOMPurify.sanitize(career.html));
                                });
                                if (!$('#cluster-careers-container').length) {
                                    $('#career-search-results-container .careers a').attr('target', '_blank');
                                }
                            } else {
                                const noResultsSubtitle = $('#career-search-subtitle').empty();
                                noResultsSubtitle.append(
                                    buildSubtitleIcon('fa-exclamation-triangle'),
                                    document.createTextNode(` No careers found for "${searchTerm}"!`),
                                );
                            }
                        },
                    });
                }
            }, 500),
        );
    };

    return {
        init,
    };
}());
